import { render, staticRenderFns } from "./sliderCategorias.vue?vue&type=template&id=02e8a5af&scoped=true&"
import script from "./sliderCategorias.vue?vue&type=script&lang=js&"
export * from "./sliderCategorias.vue?vue&type=script&lang=js&"
import style0 from "./sliderCategorias.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./sliderCategorias.vue?vue&type=style&index=1&id=02e8a5af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e8a5af",
  null
  
)

export default component.exports